var map = {
	"./decidim/avatar-multiuser.png": 27863,
	"./decidim/brands/google.svg": 34414,
	"./decidim/cc-badge.png": 52765,
	"./decidim/decidim-logo.svg": 5029,
	"./decidim/default-avatar.svg": 34693,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 9563,
	"./decidim/icons.svg": 41748,
	"./decidim/pattern.png": 71303,
	"./decidim/placeholder-card-g.svg": 13916,
	"./decidim/placeholder-card-l.svg": 15527,
	"./decidim/placeholder.jpg": 70078,
	"./decidim/remixicon.symbol.svg": 54580,
	"./decidim/vendor/leaflet/layers-2x.png": 81565,
	"./decidim/vendor/leaflet/layers.png": 25828,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 57813,
	"./decidim/vendor/leaflet/marker-icon.png": 22380,
	"./decidim/vendor/leaflet/marker-shadow.png": 69395,
	"./decidim/vendor/social-share-button/douban.svg": 49031,
	"./decidim/vendor/social-share-button/email.svg": 52048,
	"./decidim/vendor/social-share-button/facebook.svg": 876,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 62408,
	"./decidim/vendor/social-share-button/hacker_news.svg": 15172,
	"./decidim/vendor/social-share-button/linkedin.svg": 97814,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 11727,
	"./decidim/vendor/social-share-button/pinterest.svg": 81598,
	"./decidim/vendor/social-share-button/reddit.svg": 94452,
	"./decidim/vendor/social-share-button/telegram.svg": 98297,
	"./decidim/vendor/social-share-button/tumblr.svg": 90070,
	"./decidim/vendor/social-share-button/twitter.svg": 69325,
	"./decidim/vendor/social-share-button/vkontakte.svg": 53231,
	"./decidim/vendor/social-share-button/wechat.svg": 22778,
	"./decidim/vendor/social-share-button/whatsapp.svg": 33786,
	"./decidim/vendor/social-share-button/x.svg": 89872,
	"./decidim/vendor/social-share-button/xing.svg": 6776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45798;